import { CSSProperties, FC, ReactNode, useEffect } from 'react'
import { useToggle } from 'react-use'
import { ReactComponent as Close } from '@interface-images/close-black.svg'
import { ReactComponent as WhiteClose } from '@interface-images/close-white.svg'
import { useAppSelector } from '@hooks/useAppSelector'
import OutsideClick from '@atoms/OutsideClick'
import { CloseWrapper, ContentWrapper, ModalContent, Wrapper } from './styled'

type Props = {
  children: ReactNode
  contentStyle?: CSSProperties
  onModalClose?: (visible?: boolean) => void
  onCloseClick?: () => void
  visible: boolean
  width?: string
  withoutWhiteBackground?: boolean
  withoutClose?: boolean
  withoutCloseOnOutsideClick?: boolean
}

const Modal: FC<Props> = ({
  children,
  contentStyle,
  onModalClose,
  onCloseClick,
  visible: initialVisible,
  width,
  withoutWhiteBackground = false,
  withoutClose = false,
  withoutCloseOnOutsideClick = false,
}) => {
  const onboardingStarted = useAppSelector((state) => state.onboarding.started)
  const [visible, toggleVisible] = useToggle(initialVisible)

  const resultVisible =
    typeof initialVisible !== 'undefined' ? initialVisible : visible

  const handleCloseModal = (e?: { stopPropagation: () => void }) => {
    e?.stopPropagation()
    onModalClose?.(false)
    onCloseClick?.()
    toggleVisible(false)
  }

  const handleKeyPress = (e: { key: string }) => {
    if (e.key === 'Escape') {
      handleCloseModal()
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress)

    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [])
  if (!resultVisible) return null

  return (
    <Wrapper onClick={(event) => event.stopPropagation()}>
      <OutsideClick
        onOutsideClick={(e) => {
          if (onboardingStarted || withoutClose || withoutCloseOnOutsideClick) {
            return
          }

          handleCloseModal(e)
        }}
      >
        <ModalContent
          style={contentStyle}
          withoutWhiteBackground={withoutWhiteBackground}
          width={width}
          onClick={(event) => event.stopPropagation()}
          id="modal"
        >
          {!withoutClose && (
            <CloseWrapper onClick={handleCloseModal}>
              {withoutWhiteBackground ? <WhiteClose /> : <Close />}
            </CloseWrapper>
          )}
          <ContentWrapper onKeyDown={handleKeyPress}>{children}</ContentWrapper>
        </ModalContent>
      </OutsideClick>
    </Wrapper>
  )
}

export default Modal
